const _offset = ref(0)

export class ResumeBannerOffset {
  static use() {
    return { offset: _offset as Readonly<Ref<number>> }
  }

  static set(value: number) {
    _offset.value = value
  }
}
